export default {
	"coupon.ThereAreNoCoupons": "暂无相关优惠券",
	"coupon.Loading": "正在加载...",
	"coupon.NoMore": "没有更多了~"
}